import React from 'react'
import { Provider } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { useEarnSheetContext } from '../../context/EarnSheetProvider'
import { EARN_SHEET_ACTION_TYPE, EarnSheetActionType } from '../../types'
import { EarnSheetDeposit } from './deposit/EarnSheetDeposit'
import { EarnSheetWithdraw } from './withdraw/EarnSheetWithdraw'

interface EarnSheetProps {
  isSheetOpen: boolean
}

const EARN_SHEET_ACTIONS: Record<EarnSheetActionType, React.ComponentType | null> = {
  [EARN_SHEET_ACTION_TYPE.DEPOSIT]: EarnSheetDeposit,
  [EARN_SHEET_ACTION_TYPE.WITHDRAW]: EarnSheetWithdraw,
}

export const EarnSheet = ({ isSheetOpen }: EarnSheetProps) => {
  const { earnSheetAction } = useEarnSheetContext()
  const { onClose, onBack, header } = earnSheetAction || {}

  const handleSheetClose = () => {
    onClose?.()
  }

  const EarnSheetAction = earnSheetAction ? EARN_SHEET_ACTIONS[earnSheetAction.type] : null

  return (
    <Sheet header={header} onBack={onBack} isOpen={isSheetOpen} onClose={handleSheetClose}>
      <Provider>{EarnSheetAction && <EarnSheetAction />}</Provider>
    </Sheet>
  )
}
